import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { ICentroResultado } from '../model/centro_resultado.model';

@Injectable()
export class CentroResultadoService extends EntityService<ICentroResultado> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'centro_resultado',
        urlBackend: configService.backendURL
      }
    );
  }
}
